// extracted by mini-css-extract-plugin
module.exports = {"vBoxShadow":"0 0 12px 0 rgba(0, 0, 0, 0.2)","vRadiusMiddle":"12px","menu":"MenuContext_menu__SRihi"};